import {Spinner} from '@primer/react'

import {EffectiveEntryStatus} from '../../../../helpers/effective-entry-status'
import type {EffectiveEntryStatus as EffectiveEntryStatusType} from '../../../../helpers/effective-entry-status'

export function LoadingStatusIcon({status}: {status: EffectiveEntryStatusType}) {
  if (status !== EffectiveEntryStatus.Loading) return null

  return <Spinner size="small" style={{marginLeft: -2}} />
}
